import React from 'react'
import Login from '../Auth/Login'

const GuestHome = () => {
  return (
    <>
    <Login />
    </>
  )
}

export default GuestHome